import { useAuth } from 'context/AuthProvider';
import React, { useState } from 'react'
import { Button, Col, Form, FormGroup, Input, Label, Row } from 'reactstrap'
import { apiEmpleadosService } from 'services/apiEmpleadosService';
import { apiEmpresaService } from 'services/apiEmpresaService';
import { apiLoginService } from 'services/apiLoginService';
import { showAppAlert } from "components/common/AppAlerts";

const ConfiguracionEmpleado = ({empleadoId, empresaId}) => {
  const [password, setPassword] = useState("");
  const [repeatPassword, setRepeatPassword] = useState("");


  const { empresa } = useAuth();


  const handleSubmit = async (e) => {
    e.preventDefault();

    if (password !== repeatPassword) {
      showAppAlert("Las contraseñas no coinciden.", "warning")
      return
    }

    
    try {
        await apiLoginService.putPassword(empresa.userId, { password });
       
    } finally {
      showAppAlert('Contraseña de empresa actualizada', "success")
      setPassword("")
      setRepeatPassword("")
    }

   
  }
  return (
    <>
      <Form onSubmit={handleSubmit}>
        <h3>Cambiar de contraseña</h3>
        <FormGroup>
          <Row>
            <Col>
              <Label>Nueva contraseña</Label>
              <Input type="password" value={password} onChange={(e) => setPassword(e.target.value)} minLength={6} required></Input>
            </Col>
            <Col>
              <Label>Repetir contraseña</Label>
              <Input type="password" value={repeatPassword} onChange={(e) => setRepeatPassword(e.target.value)} minLength={6} required></Input>
            </Col>
          </Row>
          <br />
          <Row className='text-right'>
            <Col>
              <Button type='submit' color='success' >Guardar</Button>
            </Col>
          </Row>

        </FormGroup>


      </Form>
    </>
  )
}

export default ConfiguracionEmpleado
